import React from 'react';
import classNames from 'classnames';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import NatureIcon from '@mui/icons-material/Nature';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ArticleIcon from '@mui/icons-material/Article';
import { getHeaderTitle } from '../utils/headerSelectors';

type HeaderAuth = {
  authenticated?: boolean;
  companyName?: string | null;
  isRestricted?: boolean;
};

type HeaderCompany = {
  name?: string | null;
};

type TopAppBarClasses = {
  appBar: string;
  appBarShift: string;
  toolbar: string;
  menuButton: string;
  menuButtonHidden: string;
  title: string;
  documentationHeaderButton: string;
  headerActions: string;
};

type TopAppBarProps = {
  auth: HeaderAuth;
  classes: TopAppBarClasses;
  company: HeaderCompany;
  isAgriIconVisible: boolean;
  menuOpen: boolean;
  onAgriClick: () => void;
  onDocsClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDrawerOpen: () => void;
  onEnergyClick: () => void;
  onProfileMenuIconClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export function TopAppBar({
  auth,
  classes,
  company,
  isAgriIconVisible,
  menuOpen,
  onAgriClick,
  onDocsClick,
  onDrawerOpen,
  onEnergyClick,
  onProfileMenuIconClick,
}: TopAppBarProps): JSX.Element {
  return (
    <AppBar
      position="absolute"
      className={classNames(classes.appBar, menuOpen && classes.appBarShift)}
    >
      <Toolbar disableGutters={!menuOpen} className={classes.toolbar}>
        {auth.authenticated && !auth.isRestricted && (
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={onDrawerOpen}
            className={classNames(classes.menuButton, menuOpen && classes.menuButtonHidden)}
            size="large"
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography component="h1" variant="h5" color="inherit" noWrap className={classes.title}>
          {getHeaderTitle(auth, company)}
        </Typography>
        <div className={classes.headerActions}>
          {false && (
            <IconButton onClick={onEnergyClick} size="large">
              <FlashOnIcon />
            </IconButton>
          )}
          {isAgriIconVisible && (
            <IconButton onClick={onAgriClick} size="large">
              <NatureIcon />
            </IconButton>
          )}
          {auth.authenticated && (
            <IconButton
              className={classes.documentationHeaderButton}
              onClick={onDocsClick}
              size="large"
            >
              <ArticleIcon />
            </IconButton>
          )}
          {auth.authenticated && (
            <IconButton onClick={onProfileMenuIconClick} size="large">
              <AccountCircle />
            </IconButton>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
}
